/** @format */

import { Link, useLocation } from 'react-router-dom';

import { useRole } from '../../Shared/hooks/CustomHooks';

const Sidebar = () => {
  const { pathname } = useLocation();
  const { can, canBoard } = useRole();

  const activeMenu = (menu) => {
    let menus = {
      FormBuilder: '/panel/form-builder',
      FormBuilderCreate: '/panel/form-builder/create',
      Province: '/panel/province',
      ProvinceCreate: '/panel/province/create',
      Organizer: '/panel/organizer',
      OrganizerCreate: '/panel/organizer/create',
      Event: '/panel/event',
      EventCreate: '/panel/event/create',
      Category: '/panel/category/create',
      CategoryCreate: '/panel/category/create',
      Field: '/panel/sport-field',
      FieldCreate: '/panel/sport-field/create',
      IDCard: '/panel/id-card',
      IDCardCreate: '/panel/id-card/create',
      Fandom: '/panel/fandom',
      FandomCreate: '/panel/fandom/create',
      UploadFile: '/panel/upload',
      Export: '/panel/excel',
      User: '/panel/user',
      Transaction: '/panel/transaction',
      Referee: '/panel/referee',
      EditProfile: '/panel/user/profile',
      MyEvent: '/panel/user/event',
      MyParticipatedEvents: '/panel/user/my-events',
      Setting: '/panel/setting',
      Gateway: '/panel/setting/gateway',
      Positions: '/panel/setting/positions',
    };

    return pathname === menus[menu];
  };

  const openSubMenu = (id) => {
    let subMenu = document.getElementById(id);
    let subMenuTags = document.getElementsByClassName('sub-menu');

    if (subMenu.classList.contains('d-none')) {
      Array.from(subMenuTags).forEach((el) => {
        el.classList.remove('d-flex');
        el.classList.add('d-none');
      });
      subMenu.classList.remove('d-none');
      subMenu.classList.add('d-flex');
    } else {
      subMenu.classList.remove('d-flex');
      subMenu.classList.add('d-none');
    }
  };

  return (
    <aside className='w-100 rounded-1 overflow-hidden mt-1 p-2'>
      <div className='bg-persian-green sidebar-header p-2 text-center'>
        <h1 className='text-dark-mode f-14 font-weight-bold'>ادمین</h1>
      </div>
      <ul className='d-flex flex-column nav border border-info p-2 '>
        <li
          className='border-bottom p-2'
          onClick={() => openSubMenu('sub-menu-15')}
        >
          <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
            + پروفایل
            {activeMenu('EditProfile') ||
            activeMenu('MyEvent') ||
            activeMenu('MyParticipatedEvents') ? (
              <span className='badge badge-pill badge-danger align-self-center'>
                .
              </span>
            ) : null}
          </span>
          <ul
            className={`${
              activeMenu('EditProfile') ||
              activeMenu('MyEvent') ||
              activeMenu('MyParticipatedEvents')
                ? 'd-flex'
                : 'd-none'
            } flex-column nav sub-menu`}
            id='sub-menu-15'
          >
            <li className='border-bottom p-2 mx-2'>
              <Link to='/panel/user/profile' className='text-dark f-13'>
                - ویرایش پروفایل
              </Link>
            </li>
            <li className='border-bottom p-2 mx-2'>
              <Link to='/panel/user/my-events' className='text-dark f-13'>
                - رویدادهای من
              </Link>
            </li>
            <li className='border-bottom p-2 mx-2'>
              <Link to='/panel/user/event' className='text-dark f-13'>
                - رویدادهای ثبت نامی
              </Link>
            </li>
          </ul>
        </li>
        {can('Super Admin') ||
        can('Dyaco Admin') ||
        canBoard() ||
        can('Provinces') ? (
          <li
            className='border-bottom p-2'
            onClick={() => openSubMenu('sub-menu-1')}
          >
            <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
              + درخواست برگذاری رویداد
              {activeMenu('Event') || activeMenu('EventCreate') ? (
                <span className='badge badge-pill badge-danger align-self-center'>
                  .
                </span>
              ) : null}
            </span>
            <ul
              className={`${
                activeMenu('Event') || activeMenu('EventCreate')
                  ? 'd-flex'
                  : 'd-none'
              } flex-column nav sub-menu`}
              id='sub-menu-1'
            >
              <li className='border-bottom p-2 mx-2'>
                <Link to='/panel/event' className='text-dark f-13'>
                  - نمایش رویداد ها
                </Link>
              </li>
              <li className='p-2 mx-2'>
                <Link to='/panel/event/create' className='text-dark f-13'>
                  - ایجاد رویداد
                </Link>
              </li>
            </ul>
          </li>
        ) : null}
        {can('Super Admin') || can('Dyaco Admin') ? (
          <>
            <li
              className='border-bottom p-2'
              onClick={() => openSubMenu('sub-menu-8')}
            >
              <span className='text-dark f-13 d-flex flex-row justify-content-between  c-pointer'>
                + تراکنش ها
                {activeMenu('Transaction') ? (
                  <span className='badge badge-pill badge-danger align-self-center'>
                    .
                  </span>
                ) : null}
              </span>
              <ul
                className={`${
                  activeMenu('Transaction') ? 'd-flex' : 'd-none'
                } d-none flex-column nav sub-menu`}
                id='sub-menu-8'
              >
                <li className='border-bottom p-2 mx-2'>
                  <Link to='/panel/transaction' className='text-dark f-13'>
                    - نمایش لیست تراکنش ها
                  </Link>
                </li>
              </ul>
            </li>

            <li
              className='border-bottom p-2'
              onClick={() => openSubMenu('sub-menu-2')}
            >
              <span className='text-dark f-13 d-flex flex-row justify-content-between  c-pointer'>
                + برگذار کنندگان
                {activeMenu('Organizer') || activeMenu('OrganizerCreate') ? (
                  <span className='badge badge-pill badge-danger align-self-center'>
                    .
                  </span>
                ) : null}
              </span>
              <ul
                className={`${
                  activeMenu('Organizer') || activeMenu('OrganizerCreate')
                    ? 'd-flex'
                    : 'd-none'
                } d-none flex-column nav sub-menu`}
                id='sub-menu-2'
              >
                <li className='border-bottom p-2 mx-2'>
                  <Link to='/panel/organizer' className='text-dark f-13'>
                    - نمایش برگزار کنندگان
                  </Link>
                </li>
                <li className='p-2 mx-2'>
                  <Link to='/panel/organizer/create' className='text-dark f-13'>
                    - ایجاد برگزار کننده
                  </Link>
                </li>
              </ul>
            </li>
            <li
              className='border-bottom p-2'
              onClick={() => openSubMenu('sub-menu-3')}
            >
              <span className='text-dark f-13 d-flex flex-row justify-content-between  c-pointer'>
                + دسته بندی ها
                {activeMenu('Category') || activeMenu('CategoryCreate') ? (
                  <span className='badge badge-pill badge-danger align-self-center'>
                    .
                  </span>
                ) : null}
              </span>
              <ul
                className={`${
                  activeMenu('Category') || activeMenu('CategoryCreate')
                    ? 'd-flex'
                    : 'd-none'
                } flex-column nav sub-menu`}
                id='sub-menu-3'
              >
                <li className='border-bottom p-2 mx-2'>
                  <Link to='/panel/category' className='text-dark f-13'>
                    - نمایش دسته بندی ها
                  </Link>
                </li>
                <li className='p-2 mx-2'>
                  <Link to='/panel/category/create' className='text-dark f-13'>
                    - ایجاد دسته بندی ها
                  </Link>
                </li>
              </ul>
            </li>

            <li
              className='border-bottom p-2'
              onClick={() => openSubMenu('sub-menu-9')}
            >
              <span className='text-dark f-13 d-flex flex-row justify-content-between  c-pointer'>
                + رشته ها
                {activeMenu('Field') || activeMenu('FieldCreate') ? (
                  <span className='badge badge-pill badge-danger align-self-center'>
                    .
                  </span>
                ) : null}
              </span>
              <ul
                className={`${
                  activeMenu('Field') || activeMenu('FieldCreate')
                    ? 'd-flex'
                    : 'd-none'
                } flex-column nav sub-menu`}
                id='sub-menu-9'
              >
                <li className='border-bottom p-2 mx-2'>
                  <Link to='/panel/sport-field' className='text-dark f-13'>
                    - نمایش رشته ها
                  </Link>
                </li>
                <li className='p-2 mx-2'>
                  <Link
                    to='/panel/sport-field/create'
                    className='text-dark f-13'
                  >
                    - ایجاد رشته
                  </Link>
                </li>
              </ul>
            </li>
          </>
        ) : null}
        {can('Super Admin') || can('Dyaco Admin') ? (
          <>
            <li
              className='border-bottom p-2'
              onClick={() => openSubMenu('sub-menu-12')}
            >
              <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
                + استان
                {activeMenu('Province') || activeMenu('ProvinceCreate') ? (
                  <span className='badge badge-pill badge-danger align-self-center'>
                    .
                  </span>
                ) : null}
              </span>
              <ul
                className={`${
                  activeMenu('Province') || activeMenu('ProvinceCreate')
                    ? 'd-flex'
                    : 'd-none'
                } d-none flex-column nav sub-menu`}
                id='sub-menu-12'
              >
                <li className='border-bottom p-2 mx-2'>
                  <Link to='/panel/province' className='text-dark f-13'>
                    - نمایش استان ها
                  </Link>
                </li>
                <li className='p-2 mx-2'>
                  <Link to='/panel/province/create' className='text-dark f-13'>
                    - ایجاد استان
                  </Link>
                </li>
              </ul>
            </li>

            <li
              className='border-bottom p-2'
              onClick={() => openSubMenu('sub-menu-4')}
            >
              <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
                + فرم ساز
                {activeMenu('FormBuilder') ||
                activeMenu('FormBuilderCreate') ? (
                  <span className='badge badge-pill badge-danger align-self-center'>
                    .
                  </span>
                ) : null}
              </span>
              <ul
                className={`${
                  activeMenu('FormBuilder') || activeMenu('FormBuilderCreate')
                    ? 'd-flex'
                    : 'd-none'
                } d-none flex-column nav sub-menu`}
                id='sub-menu-4'
              >
                <li className='border-bottom p-2 mx-2'>
                  <Link to='/panel/form-builder' className='text-dark f-13'>
                    - نمایش فرم ها
                  </Link>
                </li>
                <li className='p-2 mx-2'>
                  <Link
                    to='/panel/form-builder/create'
                    className='text-dark f-13'
                  >
                    - ایجاد فرم
                  </Link>
                </li>
              </ul>
            </li>
            <li
              className='border-bottom p-2'
              onClick={() => openSubMenu('sub-menu-5')}
            >
              <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
                + آپلود فایل
                {activeMenu('UploadFile') ? (
                  <span className='badge badge-pill badge-danger align-self-center'>
                    .
                  </span>
                ) : null}
              </span>
              <ul
                className={`${
                  activeMenu('UploadFile') ? 'd-flex' : 'd-none'
                } flex-column nav sub-menu`}
                id='sub-menu-5'
              >
                <li className='border-bottom p-2 mx-2'>
                  <Link to='/panel/upload' className='text-dark f-13'>
                    - آپلود فایل
                  </Link>
                </li>
              </ul>
            </li>
          </>
        ) : null}
        {can('Super Admin') ||
        can('Dyaco Admin') ||
        canBoard() ||
        can('Provinces') ? (
          <li
            className='border-bottom p-2'
            onClick={() => openSubMenu('sub-menu-6')}
          >
            <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
              + خروجی اکسل
              {activeMenu('Export') ? (
                <span className='badge badge-pill badge-danger align-self-center'>
                  .
                </span>
              ) : null}
            </span>
            <ul
              className={`${
                activeMenu('Export') ? 'd-flex' : 'd-none'
              } flex-column nav sub-menu`}
              id='sub-menu-6'
            >
              <li className='border-bottom p-2 mx-2'>
                <Link to='/panel/excel' className='text-dark f-13'>
                  - فایل ها
                </Link>
              </li>
            </ul>
          </li>
        ) : null}
        {can('Super Admin') || can('Dyaco Admin') ? (
          <li
            className='border-bottom p-2'
            onClick={() => openSubMenu('sub-menu-7')}
          >
            <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
              + کاربران
              {activeMenu('User') ? (
                <span className='badge badge-pill badge-danger align-self-center'>
                  .
                </span>
              ) : null}
            </span>
            <ul
              className={`${
                activeMenu('User') ? 'd-flex' : 'd-none'
              } flex-column nav sub-menu`}
              id='sub-menu-7'
            >
              <li className='border-bottom p-2 mx-2'>
                <Link to='/panel/user' className='text-dark f-13'>
                  - لیست کاربران
                </Link>
              </li>
              <li className='border-bottom p-2 mx-2'>
                <Link to='/panel/user/create' className='text-dark f-13'>
                  - افزودن کاربر جدید
                </Link>
              </li>
            </ul>
          </li>
        ) : null}

        {can('Super Admin') || can('Dyaco Admin') ? (
          <>
            <li
              className='border-bottom p-2'
              onClick={() => openSubMenu('sub-menu-10')}
            >
              <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
                + آی دی کارت
                {activeMenu('IDCard') || activeMenu('IDCardCreate') ? (
                  <span className='badge badge-pill badge-danger align-self-center'>
                    .
                  </span>
                ) : null}
              </span>
              <ul
                className={`${
                  activeMenu('IDCard') || activeMenu('IDCardCreate')
                    ? 'd-flex'
                    : 'd-none'
                } flex-column nav sub-menu`}
                id='sub-menu-10'
              >
                <li className='border-bottom p-2 mx-2'>
                  <Link to='/panel/id-card' className='text-dark f-13'>
                    - لیست آی دی کارت
                  </Link>
                </li>
                <li className='border-bottom p-2 mx-2'>
                  <Link to='/panel/id-card/create' className='text-dark f-13'>
                    - افزودن آی دی کارت جدید
                  </Link>
                </li>
              </ul>
            </li>
            <li
              className='border-bottom p-2'
              onClick={() => openSubMenu('sub-menu-11')}
            >
              <span className='text-dark f-13 d-flex flex-row justify-content-between c-pointer'>
                + هواداری
                {activeMenu('Fandom') || activeMenu('FandomCreate') ? (
                  <span className='badge badge-pill badge-danger align-self-center'>
                    .
                  </span>
                ) : null}
              </span>
              <ul
                className={`${
                  activeMenu('Fandom') || activeMenu('FandomCreate')
                    ? 'd-flex'
                    : 'd-none'
                } flex-column nav sub-menu`}
                id='sub-menu-11'
              >
                <li className='border-bottom p-2 mx-2'>
                  <Link to='/panel/fandom' className='text-dark f-13'>
                    - لیست تیم ها
                  </Link>
                </li>
                <li className='border-bottom p-2 mx-2'>
                  <Link to='/panel/fandom/create' className='text-dark f-13'>
                    - افزودن تیم جدید
                  </Link>
                </li>
              </ul>
            </li>
          </>
        ) : null}

        {can('Super Admin') || can('Dyaco Admin') ? (
          <>
            <li
              className='border-bottom p-2'
              onClick={() => openSubMenu('sub-menu-16')}
            >
              <span className='text-dark f-13 d-flex flex-row justify-content-between  c-pointer'>
                + تنظیمات
                {activeMenu('Settig') || activeMenu('Gateway') || activeMenu('Positions') ? (
                  <span className='badge badge-pill badge-danger align-self-center'>
                    .
                  </span>
                ) : null}
              </span>
              <ul
                className={`${
                  activeMenu('Setting') || activeMenu('Gateway') || activeMenu('Positions')
                    ? 'd-flex'
                    : 'd-none'
                } flex-column nav sub-menu`}
                id='sub-menu-16'
              >
                <li className='border-bottom p-2 mx-2'>
                  <Link to='/panel/setting' className='text-dark f-13'>
                    - تنظیمات عمومی
                  </Link>
                </li>
                <li className='border-bottom p-2 mx-2'>
                  <Link to='/panel/setting/gateway' className='text-dark f-13'>
                    - درگاه های پرداخت
                  </Link>
                </li>
                <li className='border-bottom p-2 mx-2'>
                  <Link
                    to='/panel/setting/positions'
                    className='text-dark f-13'
                  >
                    - سمت‌ها
                  </Link>
                </li>
              </ul>
            </li>
          </>
        ) : null}
      </ul>
    </aside>
  );
};

export default Sidebar;
